import {texture} from "p3";
import NPC from "./NPC";
import definitions from "../../../definitions";
import GameScene from "../../../scenes/GameScene";

export default class NPCSuzie extends NPC {
    constructor() {
        super(definitions.NPC_ID.SUZIE);

        this._moved = false;
        this.collisionRadius = 200;
        this.collisionOffsetX = 100;
        this.collisionOffsetY = -170;
        this.turnToFacePlayer = false;
    }

    init() {
        super.init();

        this.addViewWithTexture(texture("boss_suzie_idle_00"));

        this.addShadow(definitions.SHADOW_SIZE.LARGE, 1, new PIXI.Point(20, -50));
        this.animateIdle(1);

        this._view.scale.x = -1;
        this._view.x = 150;

        const data = GameScene.active.questManager.isQuestComplete('quest_1', 'suzie');
       // //console.log(data);
        if(data) {
            this.moveToDefeatedPosition();
        }
    }

    moveToDefeatedPosition() {
        if (this._moved) {
            return;
        }

        this._moved = true;
        this.x += 460;
        this.y -= 50;
        this._view.scale.x = 1;
        this._view.x = 0;
    }

    onViewAdded() {
        super.onViewAdded();

        this.status.x += 80;
    }
}